import React from 'react';
import { BRAND } from './statuses';
import { MessageBubble } from './MessageBubble';
import type { TicketMessage } from './ticketApi';

interface Props {
  messages: TicketMessage[];
}

export const ConversationThread: React.FC<Props> = ({ messages }) => {
  if (!messages || messages.length === 0) {
    return (
      <div
        style={{
          padding: 40,
          textAlign: 'center',
          color: BRAND.textMuted,
          fontSize: 14,
        }}
      >
        No messages yet.
      </div>
    );
  }
  return (
    <div>
      {messages.map((m) => (
        <MessageBubble key={m.id} message={m} />
      ))}
    </div>
  );
};
